<template>
  <v-app>
    <vertical-nav-menu
      :is-drawer-open.sync="isDrawerOpen"
      :is-mini-panel.sync="isMiniPanel"
    ></vertical-nav-menu>
    <v-app-bar app absolute color="#fff">
      <div class="boxed-container w-full">
        <div class="d-flex align-center justify-sm-space-between mx-6">
          <div class="left-box d-flex align-center">
            <!-- 代码勿删  -->
            <!-- <v-app-bar-nav-icon
              class="d-block"
              @click="isMiniPanel = !isMiniPanel"
            ></v-app-bar-nav-icon>
            <v-divider class="divider" vertical></v-divider> -->
            <Crumbs />
          </div>
          <div class="right-box d-flex align-center">
            <v-btn class="btn-wrapper" text @click="refreshRecommend">
              <v-icon>
                {{ icons.mdiRefresh }}
              </v-icon>
              <span class="download-box">推荐刷新</span>
            </v-btn>

            <v-btn class="btn-wrapper" text @click="openDownLoadBox">
              <v-icon>
                {{ icons.mdiDownload }}
              </v-icon>
              <span class="download-box">下载中心</span>
            </v-btn>

            <span class="user-name cursor">{{ currentUserName }}</span>
            <!-- <app-bar-user-menu></app-bar-user-menu> -->
          </div>
        </div>
      </div>
    </v-app-bar>

    <v-main class="main">
      <!-- <template v-if="showBreadcrumb">
        <v-breadcrumbs :items="breadcrumbItem" class="breadcrumb">
          <template v-slot:item="{ item }">
            <v-breadcrumbs-item :href="item.href" :disabled="item.disabled">
              {{ item.text.toUpperCase() }}
            </v-breadcrumbs-item>
          </template>
        </v-breadcrumbs>
      </template> -->
      <div class="app-content-container boxed-container pa-4">
        <slot></slot>
      </div>
    </v-main>
    <DownloadDialog
      :hide-dialog-visible.sync="hideDialogVisible"
    ></DownloadDialog>
  </v-app>
</template>

<script>
import { ref, computed } from 'vue'
import { mdiMagnify, mdiGithub, mdiDownload, mdiRefresh } from '@mdi/js'
import { useRouter } from '@/utils'
import { useUserStore } from '@/store/app'
import dashboardService from '@/request/api/dashboard'
import snackbar from '@/utils/snackbar'
import VerticalNavMenu from './components/vertical-nav-menu/VerticalNavMenu.vue'
import Crumbs from './components/Crumbs.vue'
import DownloadDialog from './components/DownloadDialog.vue'

// import AppBarUserMenu from './components/AppBarUserMenu.vue'

export default {
  components: {
    VerticalNavMenu,

    // AppBarUserMenu,
    Crumbs,
    DownloadDialog,
  },
  setup() {
    const isDrawerOpen = ref(null) // 是否展示菜单抽屉

    const isMiniPanel = ref(false)

    const { route } = useRouter()

    const store = useUserStore()
    const currentUserName = computed(() => store.userInfo.username)
    // 面包屑
    const breadcrumbItem = [
      {
        text: 'Dashboard',
        disabled: false,
        href: '/dashboard',
      },
      {
        text: 'Forum Mgmt.',
        disabled: false,
        href: '/forum/pgc-list',
      },
      {
        text: 'UGCLIST',
        disabled: true,
        href: 'forum/ugc-list',
      },
    ]
    const showBreadcrumb = computed(() => !route.value.meta?.hideBreadcrumbs)

    const hideDialogVisible = ref(false)
    const openDownLoadBox = () => {
      hideDialogVisible.value = true
    }

    const refreshRecommend = async () => {
      console.log('refreshRecommend')
      try {
        const res = await dashboardService.refreshRedisCache()
        console.log(res)
        snackbar.success('刷新成功!')
      } catch (error) {
        snackbar.error(error.message)
      }
    }

    return {
      isDrawerOpen,
      isMiniPanel,
      breadcrumbItem,
      showBreadcrumb,
      currentUserName,

      // Icons
      icons: {
        mdiMagnify,
        mdiGithub,
        mdiDownload,
        mdiRefresh,
      },
      hideDialogVisible,
      openDownLoadBox,
      refreshRecommend,
    }
  },
}
</script>

<style lang="scss" scoped>
:deep(.v-app-bar) {
  .v-toolbar__content {
    padding: 0;

    .app-bar-search {
      .v-input__slot {
        padding-left: 18px;
      }
    }
  }
}

.boxed-container {
  // max-width: 1440px;
  margin-left: auto;
  margin-right: auto;
  .left-box {
    width: 85%;
    .divider {
      margin-left: 14px;
      margin-right: 16px;
    }
  }
  .user-name {
    margin-left: 24px;
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;
    text-transform: capitalize;
    color: #000000;
  }
  .btn-wrapper {
    margin-left: 24px;
  }
  .right-box {
    .download-box {
      font-size: 16px;
      color: #1a1a1a;
    }
  }
}
.app-content-container {
  // height: calc(100vh - 104px);//有面包屑
  height: calc(100vh - 64px);
  overflow: auto;
}

//reset styles
:deep(.theme--light.v-application) {
  background-color: #dddddd;
}
:deep(.v-toolbar__extension) {
  background-color: #dddddd;
}
:deep(.breadcrumb) {
  a {
    color: #1a1a1a;
  }
}
:deep(.v-breadcrumbs) {
  padding-top: 8px;
  padding-left: 16px;
  padding-bottom: 0;
}
</style>
